import PropTypes from 'prop-types';
import NoImage from 'assets/icons/no-image.svg';
import SanityImage from '@sanity-image';
import styles from './student-artwork.module.scss';

export const StudentArtwork = ({
	artwork,
	handleObjectClick,
	index,
	enforceMaxWidth,
}) => {
	const handleObjectClickOrIgnore = handleObjectClick
		? handleObjectClick
		: () => {};
	return (
		<figure
			className="edp-object"
			onClick={(e) => handleObjectClickOrIgnore(e, index)}
		>
			<div className={styles.artworkImageWrapper}>
				{artwork?.image ? (
					<SanityImage
						className={`${styles.artworkImage} ${enforceMaxWidth && styles.artworkImageGrid}`}
						image={artwork.image}
					/>
				) : (
					<NoImage className={styles.noImageSvg} />
				)}
			</div>
			<figcaption className={styles['object__caption']}>
				<div className={styles.artworkTitle}>{artwork?.title}</div>
				<div className={styles.artworkBody}>
					<div className={styles.artworkStudent}>{artwork?.student}</div>
					{!!artwork?.grade && (
						<div className={styles.artworkGrade}>Grade: {artwork?.grade}</div>
					)}
				</div>
			</figcaption>
		</figure>
	);
};

StudentArtwork.propTypes = {
	enforceMaxWidth: PropTypes.bool,
	handleObjectClick: PropTypes.func,
	index: PropTypes.any,
	artwork: PropTypes.shape({
		title: PropTypes.string,
		student: PropTypes.string,
		grade: PropTypes.string,
		materials: PropTypes.string,
		school: PropTypes.string,
		studentStatement: PropTypes.array,
		teacherStatement: PropTypes.array,
		image: PropTypes.object,
	}),
};

export default StudentArtwork;
